import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const DevResourceViewerLine = ({ label, value }) => {
  return (
    <Box
      display={'flex'}
    >
      <Text
        variant={'body1'}
        color={'black'}
        value={`${label}: `}
        weight={'bold'}
        component={'span'}
      />
      <Text
        variant={'body1'}
        color={'black'}
        value={value}
        component={'span'}
      />
    </Box>
  );
};

DevResourceViewerLine.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default DevResourceViewerLine;
